import { render, staticRenderFns } from "./veStuHygieneModifyEdit.vue?vue&type=template&id=38b2d69c&scoped=true"
import script from "./veStuHygieneModifyEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneModifyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2d69c",
  null
  
)

export default component.exports